import React from 'react'
import Portal from '../portal'
import { getCatesTree, getTagsTree, getProductListByType } from '../service'
import { getImgUrl, throttle, hbsBoolean, i18n, getPLink } from '../../common/util'
import Fallback from '../fallback'
import { AppContext } from '../../config/context'

class List extends React.Component {
    constructor() {
        super(...arguments)
        this.state = {
            secondLevel: [],
            thirdLevel: [],
            showSecondLevel: false,
            showThirdLevel: false,
            ...window._inject_app_data_
        }
        this.loadFlag = false
    }

    componentDidMount() {
        this.state.hasMore && window.addEventListener('scroll', this.scrollListener)
        const typeInfo = {
            c: {
                request: getCatesTree,
                key: 'categoryId'
            },
            t: {
                request: getTagsTree,
                key: 'tagId'
            }
        }[this.state.type]
        if (!typeInfo) {
            return
        }
        const id = this.state.navs[0][typeInfo.key]
        const sid = this.state.navs[1][typeInfo.key]
        typeInfo.request().then(tree => {
            tree = (tree.find(f => f.id === id) || { children: [] }).children
            this.setState({
                secondLevel: tree.map(c => ({ id: c.id, name: c.name })),
                thirdLevel: (tree.find(f => f.id === sid) || { children: [] }).children.map(c => ({ id: c.id, name: c.name }))
            })
        })
        document.addEventListener('click', () => {
            this.setState({
                showSecondLevel: false,
                showThirdLevel: false
            })
        })
    }

    scrollListener = throttle(() => {
        const { top } = document.getElementById('list-page-anchor').getBoundingClientRect()
        const { clientHeight } = document.documentElement
        if (top + 60 <= clientHeight) {
            this.loadMore()
        }
    })

    loadMore = () => {
        if (!this.loadFlag && this.state.hasMore) {
            this.loadFlag = true
            const { type, id, page, pageSize, list } = this.state
            const nextPage = page + 1
            getProductListByType(type, id, nextPage, pageSize).then(({ page: data }) => {
                const { records, total } = data
                const hasMore = total > nextPage * pageSize
                this.setState({
                    list: [...list, ...records],
                    page: nextPage,
                    hasMore
                })
                !hasMore && window.removeEventListener('scroll', this.scrollListener)
            }).finally(() => {
                this.loadFlag = false
            })
        }
    }

    expandCate = (e, index) => {
        e.stopPropagation()
        const property = ['showSecondLevel', 'showThirdLevel'][index]
        const newState = {
            showSecondLevel: false,
            showThirdLevel: false
        }
        if (!this.state[property]) {
            const arr = this.state[['secondLevel', 'thirdLevel'][index]]
            arr.length && (newState[property] = true)
        }
        this.setState(newState)
    }

    goToList = (id) => {
        location.href = `/l/${this.state.type}_${id}`
    }

    renderCates = (arr) => {
        const { lang } = this.context.user
        return <div className="product-nav-drop" onClick={e => e.stopPropagation()}>
            {
                arr.map(a => (<div className="product-nav-item" onClick={() => this.goToList(a.id)}>{i18n(a.name, lang)}</div>))
            }
        </div>
    }

    render() {
        const state = this.state
        const { lang } = this.context.user
        return <div className={state.total ? 'list-page-content' : 'list-page-content none'}>
            <div className="product-navs-wrapper">
                {
                    state.showDesc
                        ? <ul className="product-navs-ul">
                            <li className="product-nav">
                                <span>商城</span>
                                <i className="product-nav-arrow"></i>
                            </li>
                            <li className="product-nav">
                                <span>{i18n(state.desc, lang)}</span>
                                <i className="product-nav-arrow"></i>
                            </li>
                            <li className="product-nav">
                                <span>{i18n(state.navs[0].name, lang)}</span>
                            </li>
                        </ul>
                        : <ul className="product-navs-ul">
                            <li className="product-nav">
                                <span>商城</span>
                                <i className="product-nav-arrow"></i>
                            </li>
                            <li className={state.showSecondLevel ? 'product-nav cate active' : 'product-nav cate'} onClick={e => { this.expandCate(e, 0) }}>
                                <span>{i18n(state.navs[0].name, lang)}</span>
                                <i className="product-nav-arrow"></i>
                                {
                                    state.showSecondLevel && this.renderCates(state.secondLevel)
                                }
                            </li>
                            {
                                hbsBoolean(state.navs[2])
                                    ? <li className={state.showThirdLevel ? 'product-nav cate active' : 'product-nav cate'} onClick={e => { this.expandCate(e, 1) }}>
                                        <span>{i18n(state.navs[1].name, lang)}</span>
                                        <i className="product-nav-arrow"></i>
                                        {
                                            state.showThirdLevel && this.renderCates(state.thirdLevel)
                                        }
                                    </li>
                                    : <li className="product-nav">
                                        <span>{i18n(state.navs[1].name, lang)}</span>
                                    </li>
                            }
                            {
                                hbsBoolean(state.navs[2]) && <li className="product-nav">
                                    <span>{i18n(state.navs[2].name, lang)}</span>
                                </li>
                            }
                        </ul>
                }
            </div>
            {
                state.total > 0 && <ul className="list-page-ul">
                    {
                        state.list.map((i, n) => (<a key={i.goodsId} target="_blank" href={getPLink(i)}>
                            <li className={(n + 1) % 4 === 0 ? 'list-page-item nthc4' : 'list-page-item'}>
                                <img alt="商品图片" className="list-page-item-img" src={getImgUrl(i.imgUrl)}></img>
                                <div className="list-page-item-info">
                                    <p className="name">{i18n(i.name, lang)}</p>
                                    <p className="price">
                                        <span>&yen;</span>
                                        <span className="main">{i.salePrice}</span>
                                        {
                                            hbsBoolean(i.primePrice) && <span className="op">&yen;{i.primePrice}</span>
                                        }
                                        {
                                            hbsBoolean(i.tags) && <span className="tag">{i18n(i.tags[0].name, lang)}</span>
                                        }
                                    </p>
                                </div>
                            </li>
                        </a>))
                    }
                </ul>
            }
            {
                state.total > 0 && <div className="list-more-wrapper">
                    {
                        state.hasMore ? <div className="list-page-more more" id="list-page-anchor">{i18n('加载更多 +', lang)}</div> : <div className="list-page-more">{i18n('没有更多了……', lang)}</div>
                    }
                </div>
            }
            {
                !state.total && <Fallback type={2}></Fallback>
            }
        </div>
    }
}

List.contextType = AppContext
export default Portal(List, 'list-page-container')